import React from 'react'

import { Button } from 'antd'

import '../styles/Global.scss'

/*
  此弹窗支持（文字自定义） 是否显示取消按钮（默认不显示）
*/
class MyModal extends React.Component {
  render() {
    return (
      <div className='Tips-container'>
        <div className='Tips-item-container'>
          <div className='Tips-item-title'>
            <div></div>
            {this.props.title}
          </div>
          <div className='Tips-item-content'>{this.props.content}</div>
          <div className='Tips-item-btn-container'>
            <Button type='primary' onClick={this.props.confirmHandler}>
              {this.props.confirmText}
            </Button>
            <div
              className='cancel-btn'
              style={{ display: this.props.showCancel ? 'block' : 'none' }}
              onClick={this.props.cancelHandler}
            >
              {this.props.cancelText}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MyModal



// WEBPACK FOOTER //
// ./src/components/MyModal.jsx